__turbopack_context__.v({
  "group": "IXlRxq_group",
  "groupLabel": "IXlRxq_groupLabel" + " " + __turbopack_context__.i(917291)["lbMetaLabel"],
  "rowList": "IXlRxq_rowList",
  "section": "IXlRxq_section",
  "sectionTitle": "IXlRxq_sectionTitle" + " " + __turbopack_context__.i(917291)["lbMetaLabel"],
});
